import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@jutro/components';
import { renderContentFromMetadata } from '@jutro/uiconfig';

import metadata from './CreateAccountFAQItem.metadata.json5';
import styles from './CreateAccountFAQItem.module.scss';

function CreateAccountFAQItem(props) {
    const { data } = props;
    const [isOpen, setIsOpen] = useState(false);

    const overrides = {
        faqItemRoot: {
            className: styles.faqItemContainer
        },
        faqHeader: {
            className: styles.itemContainer
        },
        faqQuestion: {
            content: data && data.question,
            className: isOpen
                ? styles.questionOpen
                : styles.questionClosed
        },
        faqAnswer: {
            content: data && data.answer,
            className: styles.answer
        }
    };

    return (
        <div className={styles.faqItemContainer}>
            <div
                onClick={() => setIsOpen(!isOpen)}
                className={styles.itemContainer}
            >
                {renderContentFromMetadata(
                    metadata.componentContent.content[0],
                    overrides
                )}

                <Icon
                    icon={isOpen ? 'mi-expand-less' : 'mi-expand-more'}
                    className={styles.icon}
                />
            </div>

            {isOpen && (
                <div className={styles.answer}>
                    {data && data.answer}
                </div>
            )}
        </div>
    );
}

CreateAccountFAQItem.propTypes = {
    data: PropTypes.shape({})
};

CreateAccountFAQItem.defaultProps = {
    data: {}
};

export default CreateAccountFAQItem;
